import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { formatNumber } from '@/shared/helpers/format-number';
import { formatToPercentage } from '@/shared/helpers/formatToPercentage';

import { type PrizeNameProps } from './types';

import s from './index.module.scss';

export const TicketPrizeName = ({ prize }: PrizeNameProps) => {
  const { t } = useTranslation();

  const isPartOnly = prize.partSize < 1;

  const percent = isPartOnly
    ? formatToPercentage((prize.collectedPartsCount ?? 0) / (prize.targetPartsCount ?? 0))
    : undefined;

  return (
    <>
      <div className={s.name}>
        {formatNumber(prize.amount, t)} {t('tickets', { count: prize.amount })}
      </div>
      {isPartOnly && (
        <div className={clsx(s.description, s.fill)}>
          {t('Collected')}: <span className={s.value}>{percent}%</span>
        </div>
      )}
    </>
  );
};
